import React from 'react';
import { Field, Form } from 'react-final-form';
import ErrorIcon from '../../../../assets/images/Failed.svg';
import SuccessIcon from '../../../../assets/images/success-blue.svg';
import TextInput from '../../../../components/formFields/TextInput';
import Modal from '../../../../components/modal/ModalForm';
import SpreadsheetViewer from '../../../../components/spreadSheetViewer/SpreadSheetViewer';
import APPCONSTANTS from '../../../../constants/appConstants';
import ERRORS from '../../../../constants/error';
import { composeValidators, required } from '../../../../utils/validation';
import { reportNameFormat, reportSizeFormat } from '../../../../utils/commonUtils';
import styles from '../../ReportList.module.scss';
import { ISelectedUserObj } from '../types';

interface IReportViewModalProps {
  show: boolean;
  data: any;
  reportType: string;
  onClose: () => void;
}

export const ReportViewModal: React.FC<IReportViewModalProps> = ({ show, data, reportType, onClose }) => {
  return (
    <Modal
      show={show}
      title={`${reportNameFormat(reportType)}`}
      size='modal-full'
      hasFooter={false}
      handleCancel={onClose}
      handleFormSubmit={onClose}
      render={() => (
        <SpreadsheetViewer
          data={data}
          isEdit={false}
          reportName={reportNameFormat(reportType).slice(0, 3)}
          colWidth={150}
          reportSize={reportSizeFormat(reportNameFormat(reportType))}
        />
      )}
    />
  );
};

interface IDHISLoginModalProps {
  show: boolean;
  data: any;
  authenticationError: boolean;
  onClose: () => void;
  onSubmit: (values: { email: string; password: string }) => void;
}

export const DHISLoginModal: React.FC<IDHISLoginModalProps> = ({
  show,
  data,
  authenticationError,
  onClose,
  onSubmit
}) => {
  return (
    <Modal
      show={show}
      title='Send Report to DHIS2'
      size='modal-md'
      autoHeight={true}
      hasFooter={false}
      handleCancel={onClose}
      // tslint:disable-next-line:no-empty
      handleFormSubmit={() => {}}
      render={() => (
        <Form
          onSubmit={onSubmit}
          render={({ handleSubmit }) => (
            <>
              <Field
                name='email'
                type='text'
                validate={composeValidators(required)}
                render={({ input, meta }) => (
                  <TextInput
                    {...input}
                    label='DHIS2 Username'
                    errorLabel='dhis2 username'
                    error={(meta.touched && meta.error) || undefined}
                  />
                )}
              />
              <div className={styles.togglePassword}>
                <Field
                  name='password'
                  type='password'
                  validate={required}
                  render={({ input, meta }) => (
                    <TextInput
                      {...input}
                      label='DHIS2 Password'
                      errorLabel='dhis2 password'
                      error={(meta.touched && meta.error) || undefined}
                      className={styles.passwordBox}
                    />
                  )}
                />
              </div>
              {authenticationError && <p className={styles.errorText}>{ERRORS.DHIS_NOT_AUTHENTICATED.message}</p>}
              <button onClick={handleSubmit} type='submit' className='mt-2 btn primary-btn w-100'>
                Login and Send to DHIS2
              </button>
            </>
          )}
        />
      )}
    />
  );
};

interface IReviewModalProps {
  show: boolean;
  data: any;
  onClose: () => void;
  onSubmit: () => void;
}

export const ReviewModal: React.FC<IReviewModalProps> = ({ show, data, onClose, onSubmit }) => {
  return (
    <Modal
      show={show}
      title='Users for Review'
      size='modal-md'
      submitText='Submit'
      cancelText='Cancel'
      autoHeight={true}
      handleCancel={onClose}
      handleFormSubmit={onSubmit}
      render={() => (
        <div>
          <ol className='row'>
            {Object.values(data as Record<string, ISelectedUserObj>)
              .filter((user) => user.selected)
              .map((user) => (
                <li key={user.id} className='col-6 user-list-item'>
                  {user.firstName} {user.lastName}
                </li>
              ))}
          </ol>
        </div>
      )}
    />
  );
};

interface IAlertModalProps {
  show: boolean;
  status: string;
  message: string;
  onClose: () => void;
}

export const AlertModal: React.FC<IAlertModalProps> = ({ show, status, message, onClose }) => {
  return (
    <Modal
      show={show}
      isAlertModal={true}
      title=''
      size='modal-md'
      autoHeight={true}
      hasFooter={false}
      // tslint:disable-next-line:no-empty
      handleFormSubmit={() => {}}
      render={() => (
        <div className={styles.alertItems}>
          <img
            className={styles.alertModalIcon}
            src={status === APPCONSTANTS.SUCCESS ? SuccessIcon : ErrorIcon}
            alt={status}
          />
          <p className={styles.alertModalText}>{message}</p>
          <button className={styles.closeButton} onClick={onClose}>
            Done
          </button>
        </div>
      )}
    />
  );
};
